import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import { Icon } from 'oxyrion-ui/lib';
import { connect } from '../../Store';
import { AnimatedFormMessageWrapper } from '../ReusableComponents';

const ErrorWrapper = styled.div`
  height: ${rem(42)};
  opacity: 0.8;
  background: ${props => (props.success ? '#70af00' : '#ff4a4a')};
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 16px;
  margin-bottom: 20px;
  border-radius: 5px;
`;

const StyledIcon = styled(Icon)`
  margin-right: ${rem(20)};
`;

class ErrorMessage extends React.Component {
  state = {
    display: false,
  };

  componentDidUpdate(prevProps) {
    const { display, timeToShow } = this.props;

    if (prevProps.display !== display) {
      this.setState({
        display,
      });
      if (timeToShow > 0) {
        setTimeout(() => this.setState({ display: false }), timeToShow * 1000);
      }
    }
  }

  render() {
    const { text, success } = this.props;
    const { display } = this.state;

    return (
      <AnimatedFormMessageWrapper display={display}>
        <ErrorWrapper success={success}>
          <StyledIcon
            name={success ? 'done' : 'exclamation'}
            size="l"
            color="white"
          />
          {text}
        </ErrorWrapper>
      </AnimatedFormMessageWrapper>
    );
  }
}

ErrorMessage.propTypes = {
  display: PropTypes.bool,
  text: PropTypes.string,
  success: PropTypes.bool,
  timeToShow: PropTypes.number,
};

ErrorMessage.defaultProps = {
  display: false,
  text: '',
  success: false,
  timeToShow: -1,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/Components/ErrorMessage/index.jsx